import React, { Component } from 'react';
import {Card, CardTitle, CardText} from 'material-ui/Card';

class Page extends Component {

  render() {
    return (
      <Card>
        <CardTitle title="Define a Research Project" subtitle="1/5" />
        <CardText>
          <p>First, you need to to outline the individual studies that compose your research project. We recommend you to consider a structure similar to proposed by Wohlin and Aurum <sup>[1]</sup> to describe the project and its decision points, as those are easily mapped into research units.</p>
          <p>[1] Wohlin C and Aurum A. Towards a decision-making structure for selecting a research design in empirical software engineering. Empirical Software Engineering, 20(6):1427-1455, 2015.</p>
        </CardText>
      </Card>
    );
  }
}

export default Page;



// WEBPACK FOOTER //
// ./src/components/Cerse/Step1.js